import script from "./Certificate.vue?vue&type=script&setup=true&lang=js"
export * from "./Certificate.vue?vue&type=script&setup=true&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=2428b182&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2428b182"]])

export default __exports__